import React from 'react';
import styled from 'styled-components';

import { DAYS_OF_THE_WEEK } from 'src/presentation/components/pages/shared/constants/dateTimeConstants';
import { SingleDayItem, SingleDayContentWrapper } from './SingleDayItem';
import { FilledContainer } from 'src/presentation/components/forms/Layout';

type WorkingHoursProps = {
  attr: string;
  dataAid: string;
};

const WorkingHours = ({ attr, dataAid }: WorkingHoursProps): JSX.Element => {
  const timeRanges = DAYS_OF_THE_WEEK.map(dayOfWeek => {
    const lowerCasedDayOfWeek = dayOfWeek.toLowerCase();
    const dayDataPath = `${attr}.${lowerCasedDayOfWeek}`;

    return <SingleDayItem key={dayDataPath} attr={dayDataPath} label={dayOfWeek} />;
  });

  return <StyledFilledContainer data-aid={`${dataAid}-content`}>{timeRanges}</StyledFilledContainer>;
};

const StyledFilledContainer = styled(FilledContainer)`
  padding: 0;

  ${SingleDayContentWrapper}:first-child {
    padding-top: 20px;
  }

  ${SingleDayContentWrapper}:last-child {
    padding-bottom: 20px;
  }
`;

export default WorkingHours;
